/**
 * Type definitions and API class for Feed Stock
 *
 * - useFeedStockQueries.ts for React Query hooks
 */

export const BEGINNING_OF_TIME = "1970-01-01T00:00:01.000Z";

export enum GENERAL_FEED_TYPE {
  HAYLAGE = "HAYLAGE",
  SILAGE = "SILAGE",
  GRAIN = "GRAIN",
  CONCENTRATED_FEED = "CONCENTRATED_FEED",
  HAY = "HAY",
}

export enum GENERAL_FEED_UNITS {
  KG = "KG",
  TONNE = "TONNE",
}

export enum PURCHASE_CURRENCY {
  GBP = "GBP",
}

export type FeedStocks = {
  id: number;
  feedStock: FeedStock[];
};

export type FeedStock = {
  type: GENERAL_FEED_TYPE;
  amount: number;
};

export default class FeedStockAPI {
  baseUrl: string;
  entity: string;
  constructor(entity: string) {
    this.baseUrl = `${import.meta.env.VITE_API_ENDPOINT}/v1/`;
    this.entity = entity;
  }

  async fetchFeedStock(params: URLSearchParams): Promise<FeedStocks> {
    const res = await fetch(`${this.baseUrl}${this.entity}?${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt") || ""}`,
        "Content-Type": "application/json",
      },
    });
    return { id: 1, feedStock: await res.json() } as FeedStocks;
  }
}

export const feedStockApi = new FeedStockAPI("feedStock");
